// icon:account-edit | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

function IconAccountEdit(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="red"
      height="5em"
      width="4em"
      {...props}
    >
      <path d="M21.7 13.35l-1 1-2.05-2.05 1-1a.55.55 0 01.77 0l1.28 1.28c.21.21.21.56 0 .77M12 18.94l6.06-6.06 2.05 2.05L14.06 21H12v-2.06M12 14c-4.42 0-8 1.79-8 4v2h6v-1.89l4-4c-.66-.08-1.33-.11-2-.11m0-10a4 4 0 00-4 4 4 4 0 004 4 4 4 0 004-4 4 4 0 00-4-4z" />
    </svg>
  );
}

export default IconAccountEdit;

  